import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {Container} from "react-bootstrap";
import React, {useEffect} from "react";
import {ShippingAddress} from "./ShippingAddress";
import {DeliveryMethod} from "./DeliveryMethod";
import {PaymentMethod} from "./PaymentMethod";
import {ReviewOrder} from "./ReviewOrder";
import {PaypalWrapper} from "./Paypal";
import {useAuth} from "../../context";
import {useBrowserTitle} from "../../hooks/useBrowserTitle";


export function RoutesCheckout() {
    useBrowserTitle("Checkout")
    return (
        <Container fluid="lg" className="">
            <Routes>
                <Route index element={<PrivatePath body={<ShippingAddress/>}/>}/>

                <Route path="/address" element={<PrivatePath><ShippingAddress/></PrivatePath>}/>
                <Route path="/delivery" element={<PrivatePath><DeliveryMethod/></PrivatePath>}/>
                <Route path="/payment" element={<PrivatePath><PaymentMethod/></PrivatePath>}/>
                <Route path="/review" element={<PrivatePath><ReviewOrder/></PrivatePath>}/>
                <Route path="/paypal" element={<PrivatePath><PaypalWrapper/></PrivatePath>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </Container>
    )
}

function PrivatePath({children}) {
    const {loggedIn} = useAuth()
    const location = useLocation()

    if (!loggedIn)
        return <Navigate to="/account/login" state={{from: location}} replace={true}/>

    return children
}

function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            navigate("/shop")
        }, 3000)
    }, []);
    return <h1>404 Page not found</h1>
}